<template>
  <b-modal
    id="editUser-modal"
    cancel-title="Annulla"
    cancel-variant="outline-secondary"
    centered
    ok-title="Modifica"
    :title="title"
    @ok="updateUserGroup"
  >
    <b-form>

      <b-form-group>
        <label
          for="shareSelect"
        >Ruolo:</label>
        <b-form-select
          id="shareSelect"
          v-model="user.profile_id"
          :options="groupsList"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormSelect,
} from 'bootstrap-vue'
import groupRepository from '@/api/groupRepository'
// import { capitalizeFirstLetter } from 'vue2-leaflet'

export default {
  name: 'ChangeRoleUserModal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormSelect,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    groupsList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    title() {
      if (this.user) {
        return `Ruolo di ${this.user.name}`
      }
      return ''
    },
  },
  mounted() {
    console.log(this.user)
  },
  methods: {
    async updateUserGroup() {
      await groupRepository.updateUserGroup(this.user.id, this.user.profile_id)
      this.$emit('reload')
    },
  },
}
</script>

    <style scoped />
